import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LoggedInUserContext } from "../../../Contexts.js";
import { Banner, BannerList } from "../../design-system/index.js";

export function TrainingBannerSoad() {
  const userContext = useContext(LoggedInUserContext);
  const { t } = useTranslation();

  const showTrainingBanner =
    userContext?.user.sessionContext?.isTrainingOrganisation ?? false;

  return showTrainingBanner ? (
    <Banner
      bannerType={BannerList.WARNING}
      body={(t("training.soad.banner.body") as string).split("\n")}
    />
  ) : null;
}
